import React, { useState } from 'react';
import './contact.css';

function ContactUs() {
  const [form, setForm] = useState({ name: '', phone: '', message: '' });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    if (!/^[A-Za-z ]+$/.test(form.name)) {
      errs.name = 'Name should contain only letters and spaces.';
    }
    if (!/^\d{10}$/.test(form.phone)) {
      errs.phone = 'Phone number should be exactly 10 digits.';
    }
    if (!form.message.trim()) {
      errs.message = 'Message is required.';
    }
    return errs;
  };

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: undefined });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    alert('Thank you for your message! We will contact you soon.');
    setForm({ name: '', phone: '', message: '' });
  };

  return (
    <>
      {/* Page Header for SEO and Google Ads Compliance */}
      <header className="page-header" style={{
        background: 'linear-gradient(135deg, #561314 0%, #8B0000 100%)',
        color: 'white',
        textAlign: 'center',
        padding: '2rem 1rem',
        marginBottom: '0'
      }}>
        <h1 style={{
          fontSize: '2.5rem',
          margin: '0 0 1rem 0',
          fontWeight: '600',
          textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
        }}>
          Contact Rameshwaram Villa - Book Your Luxury Stay
        </h1>
        <p style={{
          fontSize: '1.2rem',
          margin: '0',
          maxWidth: '800px',
          marginLeft: 'auto',
          marginRight: 'auto',
          lineHeight: '1.6',
          opacity: '0.95'
        }}>
          Get in touch with us to book your luxury villa accommodation in Pathankot. 
          Experience our premium services, indoor swimming pool, and personal movie theatre.
        </p>
      </header>
      
      <section
        className="contact-section"
        style={{
          minHeight: '100vh',
          background: `url('/images/services-bg.png') center center/cover no-repeat fixed`,
          position: 'relative',
        }}
      >
        <h2 className="contact-title">Contact Us</h2>
        <form className="contact-form" onSubmit={handleSubmit} noValidate>
          <label>
            Name
            <input type="text" name="name" value={form.name} onChange={handleChange} required pattern="[A-Za-z ]+" />
            {errors.name && <span className="contact-error">{errors.name}</span>}
          </label>
          <label>
            Phone
            <input type="tel" name="phone" value={form.phone} onChange={handleChange} required pattern="\d{10}" maxLength={10} />
            {errors.phone && <span className="contact-error">{errors.phone}</span>}
          </label>
          <label>
            Message
            <textarea name="message" value={form.message} onChange={handleChange} required rows={4} />
            {errors.message && <span className="contact-error">{errors.message}</span>}
          </label>
          <button type="submit" className="contact-submit">Send Message</button>
        </form>
      </section>
    </>
  );
}

export default ContactUs;